<script>
    export let type = 'h4'
    export let color = 'inherit'
    export let style = ''
</script>

<p
    {style}
    class={`${type} ${color === 'inherit' ? '' : color}`}
    {color}
    {...$$props}
>
    {#if $$slots}<slot />{/if}
</p>

<style>
    .h1 {
        font-style: normal;
        font-weight: 400;
        font-size: 42px;
        line-height: 48px;
        letter-spacing: 0.4px;
    }

    .h2 {
        font-style: normal;
        font-weight: 400;
        font-size: 33px;
        line-height: 40px;
        letter-spacing: 0.4px;
    }

    .h3 {
        font-weight: 400;
        font-size: 26px;
        line-height: 32px;
        letter-spacing: 0.4px;
    }

    .h4 {
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        line-height: 24px;
        letter-spacing: 0.4px;
    }
    .subhead {
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0.5px;
    }

    .body {
        font-style: normal;
        font-weight: 400;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0.2px;
    }

    .subtitle {
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.4px;
    }

    .subtitle-medium {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.4px;
    }

    .button {
        font-weight: 500;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0.5px;
    }

    .button-min {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.4px;
    }

    .caption {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.4px;
    }

    .overline {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.4px;
        text-transform: uppercase;
    }

    .label {
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.5px;
    }

    .legend {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.5px;
        text-align: justify;
    }

    .black {
        color: var(--color-typography-black);
    }

    .white {
        color: var(--color-typography-white);
    }

    .brand {
        color: var(--color-typography-brand);
    }

    .grey-800 {
        color: var(--color-typography-grey-800);
    }

    .grey-400 {
        color: var(--color-typography-grey-400);
    }

    .grey-300 {
        color: var(--color-typography-grey-300);
    }
</style>
